  import pdfFonts from "../../public/vfs_fonts";
  import pdfMake from 'pdfmake';
  // import axios from '@/axios';
  import pdfSkillSheetText from './pdfSkillSheet';

  // const stgUrl = "http://ec2-43-207-208-162.ap-northeast-1.compute.amazonaws.com:8080/api/pdf"

  export default {

    outputPDF(ids, documents, pdfApiDatas, staffName) {
      console.log("ids: ",ids, "documents: ", documents,)
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        GenShin: {
          normal: "genshin-normal.ttf",
          bold: "genshin-bold.ttf",
        },
        English: {
          normal: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
        },
      };
      const defaultStyle = "GenShin";
      
      let pdfText;

        pdfText = pdfSkillSheetText.skillSheetText(pdfApiDatas);

      const docDefinition = {
        defaultStyle: {
          font: defaultStyle,
          pageSize: "A4",
          pageOrientation: "landscape",
        },
        content: pdfText,
        styles: {

          // 職務経歴書のタイトルのスタイル
          headerC: {  
            fontSize: 15,
            bold: true
          },

          // 職務経歴書のサブタイトルのスタイル
          subheaderC: {
            fontSize: 11,
            bold: true,
          },

          
          // 職務経歴書の内容のスタイル
          infoC: {
            fontSize: 10
          },

          // 職務経歴書の業務関連のタイトルのスタイル
          headerCI: {  
            fontSize: 15,
            bold: true,
          },

          // 職務経歴書の業務関連のサブタイトルのスタイル
          subheaderCI: {
            fontSize: 10,
          },

          // 職務経歴書の業務関連の内容スタイル
          infoCI: {
            fontSize: 8
          },

          // スキルシートのタイトルのスタイル
          headerSk: {
            fontSize: 11,
            bold: true,
            alignment: 'center'
          },

          // スキルシートのサブタイトルのスタイル
          subHeaderSk: {
            fontSize: 9,
          },

          // スキルシートの重要なサブタイトル（赤色）のスタイル
          subHeaderSkRed: {
            fontSize: 6,
            color: 'red'
          },

          // スキルシートの分野と名称のスタイル
          infoHeaderSk: {
            fontSize: 7,
            alignment: 'center',
          },

          infoHeaderSkPlus: {
            fontSize: 5,
            alignment: 'center',
          },
          
          // スキルシートの内容のスタイル
          infoSk: {
            fontSize: 6,
            margin:[-2,-2,0,-2]
          },

          infoSkBold: {
            fontSize: 6,
            bold: true,
            margin:[-2,-2,0,-2]
          },
          
        }
      };
              // PDF プレビューを別タブで開く
              const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
              pdfMake.createPdf(docDefinition).download(`スキルシート_${staffName}_${today}.pdf`);



      // // PDF を Blob データとして取得
      // pdfMake.createPdf(docDefinition).getBlob(blob => {
      //   // PDF をサーバーにアップロード
      //   this.uploadPDF(blob, ids, documents);

      //   // PDF プレビューを別タブで開く
      //   pdfMake.createPdf(docDefinition).open();
      // });
    },

    // //サーバーにアップロード用
    // uploadPDF(blob, ids, documents) {
    //   const formData = new FormData();
    //   formData.append('file', blob, documents + '_' + ids + '.pdf');
    //   formData.append('ids', ids);
    //   formData.append('documents', documents);

    //   axios.post(stgUrl + '/upload', formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data',
    //     },
    //   })
    //     .catch(() => {
    //       alert('PDFのアップロード中にエラーが発生しました');
    //     });
    // },

    // async fetchPDF(ids, documents) {
    //   try {

    //     const response = await axios.get(stgUrl + '/get', { params: { 'ids': ids, 'documents': documents }, responseType: 'blob' });
    //     const url = URL.createObjectURL(response.data);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = documents + '_' + ids + '.pdf'; // 保存するファイル名
    //     link.click();
    //     URL.revokeObjectURL(url);
    //   } catch {
    //     alert('PDFの取得中にエラーが発生しました');
    //   }
    // }
  }
